module.exports = __webpack_public_path__ + "media/start_page4.3e82abf8.mp3";